import { render } from "./FilterManager.vue?vue&type=template&id=e0b872ca&ts=true"
import script from "./FilterManager.vue?vue&type=script&lang=ts"
export * from "./FilterManager.vue?vue&type=script&lang=ts"

import "./FilterManager.vue?vue&type=style&index=0&id=e0b872ca&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__